import { getUserLists } from '../api/lists'
import type { List } from '../types/list'
import type { Prompt, PromptMinified } from '../types/prompt'

export type UpdateListState = 'added' | 'removed'
interface UpdateList {
  state: UpdateListState
  id: string
  nVotes?: number
}

export const useUpdateListVote = () => useState<null | UpdateList>('voted-prompt-update', () => null)

export const useAddPromptToList = () => useState<PromptMinified[]>('list-form-added-prompts', () => [] as PromptMinified[])

export const useListPromptsListing = () => useState<Record<string, Prompt[]>>('list-prompts-listing', () => ({}))
export const useElementalLists = () => useState<Record<string, List[]>>('user-lists-by-elemental', () => ({}))
export const useTemporarySavedLists = () => useState<Record<string, string[]>>('temporary-saved-lists-by-elemental', () => ({}))

export const loadElementalLists = async (elementalId: string, isPremium?: boolean, elementaTypelId?: number) => {
  const user = useUser()
  if (!user.value)
    return

  const lists = useElementalLists()
  lists.value[elementalId || 'new-elemental'] = await getUserLists(user.value.id, {
    size: 0,
    prompt_id: elementalId || undefined,
    is_premium: isPremium || undefined,
    elemental_type_id: elementaTypelId,
  }) || []
}
